import $ from 'jquery';
import { initMobileMenu } from './mobile-menu';
//import { paintMasonryLayout } from './masonry-layout';
import { initFancyInputBox } from './fancy-input';
//import { initInfiniteScroll } from './infinite-scroll';
import { formValidationEvents } from './form/form-events';
import { initStateDropDownBox } from './state-dropdown';
import { sizePicker } from './offer-size-picker';

import { initCleaveDate } from './cleave-date';
//import { initTMIdentity } from './tm-login';

//import 'slick-carousel';
import {mobileMasker} from './mobile-masker';
import {autocomplete} from './autocomplete';
import { initSliderPro } from './slider-pro';
import { initDiscography } from './discography';

import { newsSubnav } from "./news-subnav";
import { tourTicketDropDown } from "./tour-ticket-dropdown";
import { initNewsImageSwap } from "./news-image-swap";
import { initDropdownNav } from "./dropdown-nav";
import { subNav } from './menu-submenu';
import { memberNav } from './member-menu';
import {initToggleGallery } from './gallery-toggle';
import {initScroller } from './scroller';
import { removeBrokenImage } from './remove-broken-image';
import { removeLightBoxHideItem } from './lightbox-hide-remove';
import { newsHashCommentUrl } from './news-hash-url';
//import { slider } from './slider';

import {notification} from './notification';

import { discographySubMenu } from "./discography-submenu";
//import { dropDownMenu } from "./component/dropdownMenu";
import { prepareMiniLightBox } from "./component/mini-lightbox/mini-lightbox-configure";


const polyfillStartWith = () => {
	if(!String.prototype.startsWith) {
		String.prototype.startsWith = function(searchString, position){
			return this.substr(position || 0, searchString.length) === searchString;
		};
	}

	if (window.NodeList && !NodeList.prototype.forEach) {
	  NodeList.prototype.forEach = Array.prototype.forEach;
	}
}


$(function () {
	polyfillStartWith();
	initMobileMenu();
	//paintMasonryLayout();
	initFancyInputBox();
	//initInfiniteScroll();
	initStateDropDownBox();
	formValidationEvents();
	sizePicker();

	//initTMIdentity();
	initCleaveDate();
	mobileMasker();
	autocomplete();
	prepareMiniLightBox();
	initSliderPro();
	initDiscography();
	//dropDownMenu();
	subNav();
	memberNav();
	newsSubnav();
	initDropdownNav();
	tourTicketDropDown();
	initNewsImageSwap();
	removeBrokenImage();
	removeLightBoxHideItem();
	newsHashCommentUrl();
	//slider();
	discographySubMenu();

	notification();
	initToggleGallery();
	initScroller();



});

